import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Axios from 'axios';

import {url} from '../../../Config';

import './Protocoles.css';
import ProtocoleOverview from '../../../components/protocole-overview/ProtocoleOverview';
import Chat from '../../../components/chat/Chat';
import Navbar from '../../../components/navbar/Navbar';
import Sidebar from '../../../components/sidebar/Sidebar';

class ListeAmendementsMajeursChercheur extends Component {
    constructor() {
        super();
        this.state = {
            amendements: [],
            isLoading: true,
            isEmptyRecords: false
        };
    }

    componentDidMount(){
        const profil = sessionStorage.getItem('profil');
        if(profil !== 'chercheur'){ this.props.history.goBack(); }
        
        const token = sessionStorage.getItem('token');

        Axios.get(`${url}/api/get-my-amendements-majeurs?token=${token}`).then(
            res => {
                const {amendements, count} = res.data;
                if(count == 0){
                    this.setState({isEmptyRecords: true});
                }
                this.setState({amendements, isLoading: false});
            }
        );
    }

    showLoader = () => {
        if(this.state.isLoading){
            return (
                <div class="d-flex justify-content-center">
                    <strong>Chargement...</strong>
                </div>
            )
        } else {
            return '';
        }
    }

    showEmptyRecordsAlert = () => {
        if(this.state.isEmptyRecords){
            return (
                <div className="alert alert-info m-5">
                    Vous n'avez pas de nouveaux amendements majeurs
                </div>
            )
        } else {
            return '';
        }
    }

    render() {
        const {amendements} = this.state;

        return (
            <>
                <Navbar />
                <Sidebar />
                <div className="col-md-10 offset-md-2 mt-5 pt-2">
                    <div id="liste-protocoles-chercheur-content" className="row">
                        <div className="col-md-12">
                            <div className="row liste-protocoles-chercheur bg-white">
                                <div className="col-md-12 px-4 py-2">
                                    <div className="clearfix">
                                        <span className="float-left titre text-secondary">Mes Amendements Majeurs</span>
                                    </div>                                
                                </div>

                                <div className="col-md-12 px-0 pb-5">
                                    {this.showLoader()}
                                    {this.showEmptyRecordsAlert()}

                                    {amendements.map((amendement, index) => (
                                        <ProtocoleOverview
                                            key={index}
                                            from="chercheur"
                                            type="amendement"
                                            protocole={amendement}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ListeAmendementsMajeursChercheur;